import axios from 'axios';
import { AUTH_CLEAN } from 'containers/Login/state/constants';
import { cancelScheduledRefresh } from './tokenUtils';
import { getCsrfToken } from './csrf';
import { API as baseURL } from 'config/api';
import platform from 'config/platform';
import state from '../store'; //getState, dispatch
import i18n from '../i18n';

const instance = axios.create({
    baseURL,
    withCredentials: true,
    headers: {
        accept: 'application/json',
        'content-type': 'application/json'
    }
  });

// These calls don't require a CSRF header - either they happen before a
// session exists (login/register) or aren't relevant to this repo yet (bankid/add).
const CSRF_EXEMPT = ['api/auth/login', 'api/auth/register', 'api/auth/bankid/add'];
const MUTATING_METHODS = ['post', 'put', 'patch', 'delete'];

instance.interceptors.request.use(config => {
    const { url, method } = config;
    config.headers.platform = platform;
    config.headers['platform-lang'] = {'en':'en', 'se':'sv', 'sv':'sv'}[i18n.language] || 'en';

    if (MUTATING_METHODS.includes((method || '').toLowerCase()) && !CSRF_EXEMPT.includes(url)) {
        const csrfToken = getCsrfToken();
        if (csrfToken) {
            config.headers['X-CSRF-Token'] = csrfToken;
        }
    }

    return config;
  }, error => {
    return Promise.reject(error);
});

// declare a response interceptor
instance.interceptors.response.use((response) => {
    // do something with the response data
    console.log('Response was received');

    return response;
  }, error => {
    // handle the response error
    if (+error?.response?.status === 401) {
      // session is already dead server-side, just clear local state
      console.log('>>> -- call auth clean due to 401 from BE server');
      cancelScheduledRefresh();
      state.dispatch({type: AUTH_CLEAN});
    }
    return Promise.reject(error);
});

const CancelToken = axios.CancelToken;

export default {
    get: ({ params, path , cancelCallback}) => instance.get(path, {params, cancelToken: new CancelToken(c => cancelCallback && cancelCallback(c))}),
    post: ({ params, path }) => instance.post(path, params),
    put: ({ params, path }) => instance.put(path, params),
    patch: ({ params, path }) => instance.patch(path, params),
    delete: ({ params, path }) => instance.delete(path, params)
}
